import React, { useState } from 'react';
import { Heading } from '../../common/form/form-parts';
import { useTranslator } from 'tradera/lang/translate';
import { Input } from './form-input';
import { useFormContext } from 'react-hook-form';
import PenIcon from '@tradera/blueprint/theme/icons2/pen.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

export const SwedishCompanyFormSignup = ({
    autoFillCompanyDetails,
    rules,
    serverErrors,
    onNavigate
}) => {
    const { t } = useTranslator();
    const { trigger, getValues } = useFormContext();
    const [allowEdit, setAllowEdit] = useState(!autoFillCompanyDetails);

    return (
        <>
            <Heading className="mb-7">{t('registration_almost_done')}</Heading>
            {!allowEdit ? (
                <>
                    <p className={'mb-1 font-hansen'}>
                        {t('registration_placeholder_orgnr')}
                    </p>
                    <input
                        type="text"
                        readOnly
                        value={getValues('organizationNumber')}
                        className="form-control mb-1"
                    />
                    <div className="d-flex justify-content-between">
                        <div>
                            <p className="mb-0">{getValues('companyName')}</p>
                            <p className="mb-0">{getValues('streetName')}</p>
                            <div className="d-flex mb-0">
                                <p className="mr-1">{getValues('zipCode')}</p>
                                <p>{getValues('town')}</p>
                            </div>
                        </div>
                        <Button
                            theme="link"
                            onClick={() => setAllowEdit(true)}
                            className="d-flex"
                            icon={<PenIcon />}>
                            {t('registration_edit')}
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <Input
                        name="organizationNumber"
                        type="text"
                        className="mb-2"
                        label={t('registration_placeholder_orgnr')}
                        rules={rules}
                        serverErrors={serverErrors}
                    />
                    <Input
                        name="companyName"
                        type="text"
                        className="mb-2"
                        label={t('registration_placeholder_company_name')}
                        rules={rules}
                        serverErrors={serverErrors}
                    />
                    <Input
                        name="streetName"
                        type="text"
                        label={t('registration_placeholder_address')}
                        placeholder={t('registration_placeholder_street')}
                        rules={rules}
                        serverErrors={serverErrors}
                    />
                    <div className="d-flex mb-2">
                        <Input
                            name="zipCode"
                            type="text"
                            className="mr-1"
                            placeholder={t('registration_placeholder_zip_code')}
                            rules={rules}
                            serverErrors={serverErrors}
                        />
                        <Input
                            name="town"
                            type="text"
                            className="mb-0"
                            placeholder={t('registration_placeholder_town')}
                            rules={rules}
                            serverErrors={serverErrors}
                        />
                    </div>
                </>
            )}
            <Input
                name="phoneNumber"
                type="tel"
                className="mb-2"
                label={t('registration_placeholder_phoneNumber')}
                rules={rules}
                serverErrors={serverErrors}
            />
            <Input
                name="alias"
                type="text"
                label={t('registration_validation_title_username')}
                placeholder={t('registration_placeholder_username')}
                className="mb-2"
                rules={rules}
                serverErrors={serverErrors}
            />
            <div className="mt-2">
                <button
                    type="button"
                    className="btn btn-primary btn-fluid mt-1"
                    onClick={async () => {
                        const inputsToValidate = [
                            'alias',
                            'phoneNumber',
                            'organizationNumber',
                            'companyName',
                            'streetName',
                            'zipCode',
                            'town'
                        ];

                        if (await trigger(inputsToValidate)) {
                            onNavigate();
                        }
                    }}>
                    {t('registration_continue_button')}
                </button>
            </div>
        </>
    );
};
